import { SsrCacheHints } from '@wix/thunderbolt-ssr-api'

export const SsrCacheHintsManagerSymbol = Symbol('SsrCacheHintsManager')
export const SsrRequestContextSymbol = Symbol('SsrRequestContextSymbol')

export interface ISsrCacheHintsManager {
	setCacheHints: (cacheHints: SsrCacheHints) => void
	setTpaFailure: (appDefinitionId: string) => void
	setCompFailure: (compId: string) => void
	getCacheHints: () => SsrCacheHints
}
